import { api } from '../api';
import type { AttachmentRecord, ChecklistDefinition, DraftState } from '../types';

// Every retry begins from server truth, including a submit whose response was lost.
export async function finalizeReport(id: string, token: string, state: DraftState, onLocked: () => void) {
  let result = await api.getSubmission(id,token);
  if(result.submission.status !== 'submitted') {
    await api.saveDraft(id,token,state);
    await api.submit(id,token,state);
    result = await api.getSubmission(id,token);
  }
  onLocked();
  return createStoredPdf(id,token,result);
}
export async function createStoredPdf(id:string,token:string,result:Awaited<ReturnType<typeof api.getSubmission>>) {
  const existing = result.submission.pdf_attachment_id;
  if(existing) return {downloadUrl:`/api/submissions/${id}/files/${existing}?token=${encodeURIComponent(token)}`};
  const {generateReportPdf,reportFilename}=await import('./pdf');
  const attachments=result.attachments.filter(a=>a.kind==='photo') as unknown as AttachmentRecord[];
  const state:DraftState={...result.state,id,status:'submitted',updatedAt:String(result.submission.submitted_at||''),attachments};
  const photos=attachments.map(a=>({...a,url:`/api/submissions/${id}/files/${a.id}?token=${encodeURIComponent(token)}`}));
  const blob=await generateReportPdf(result.definition as ChecklistDefinition,state,photos);
  return api.uploadPdf(id,token,blob,reportFilename(result.definition,state));
}
